import { Box, Flex, Text } from '@chakra-ui/react';
import { FormikProps } from 'formik';
import React, { useState } from 'react';

import { utils as commonUtils } from '@finley-technologies/common';
import {
  AssetVerification,
  CreditAgreement,
} from '@finley-technologies/finley-types';

import { MultiSelect } from '~/packages/common-frontend/components/MultiSelect';
import { formatSelectOptions } from '~/packages/common-frontend/components/Select';

const reportEntryStatusOptions = formatSelectOptions(
  AssetVerification.AssetVerificationOutput.ReportEntryStatusIterable,
  'title',
);

type AssetVerificationConfigProps = {
  formProps: FormikProps<CreditAgreement.Config.CommonPostgresQuery.Query.AssetVerificationQuery>;
};
export const AssetVerificationConfig = ({
  formProps,
}: AssetVerificationConfigProps) => {
  const initialState = formProps.values.parameterConfig.statusFilter.statuses;
  const [selectedOptions, setSelectedOptions] = useState<
    AssetVerification.AssetVerificationOutput.ReportEntryStatus[]
  >(initialState);
  const [titleText, setTitleText] = useState(
    initialState.map(commonUtils.toTitleCase).join(', '),
  );

  const handleChange = (
    newValue: AssetVerification.AssetVerificationOutput.ReportEntryStatus,
  ) => {
    const index = selectedOptions.indexOf(newValue);

    if (index >= 0) {
      // only remove option if multiple are selected
      if (selectedOptions.length === 1) {
        return selectedOptions;
      }

      selectedOptions.splice(index, 1);
      setSelectedOptions(selectedOptions);
    } else {
      selectedOptions.push(newValue);
    }

    setTitleText(selectedOptions.map(commonUtils.toTitleCase).join(', '));

    return selectedOptions;
  };

  return (
    <Flex flexDir="column">
      <Text w="xs">Include Statuses:</Text>
      <Box mb="2">
        <MultiSelect<AssetVerification.AssetVerificationOutput.ReportEntryStatus>
          onChange={(val) => {
            const selectedTypes = handleChange(val);
            formProps.setFieldValue(
              'parameterConfig.statusFilter.statuses',
              selectedTypes,
            );
          }}
          options={reportEntryStatusOptions}
          selectedOptions={
            formProps.values.parameterConfig.statusFilter.statuses
          }
          titleText={titleText}
        />
      </Box>
    </Flex>
  );
};
